import axios from '../../../../utills/axiosConfig';

export const fetchPurityConfigurations = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/purity-configurations', { params });
  return res.data;
};

export const addPurityConfiguration = async (purityConfiguration) => {
  try {
    const res = await axios.post('/purity-configurations', purityConfiguration);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updatePurityConfiguration = async (id, purityConfiguration) => {
  console.log('API call - Updating purity configuration:', id, purityConfiguration);
  const res = await axios.put(`/purity-configurations/${id}`, purityConfiguration);
  console.log('API response:', res.data);
  return res.data;
};

export const deletePurityConfiguration = async (id) => {
  const res = await axios.delete(`/purity-configurations/${id}`);
  return res.data;
};

export const importPurityConfigurationCSV = async (formData) => {
  const { data } = await axios.post('/purity-configurations/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 